<template>
  <section class="content" :style="{padding:'0 .99rem !important'}">
    <div class="card">
      <div class="card-body d-flex align-items-center flex-wrap">
        <div style="width: 100%;">
          <h3 style="text-align: left;">Centro de ayuda</h3>
          <hr>
        </div>
      </div>
      <div class="accordion" id="accordionExample" style="padding: 0 1rem;">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Preguntas frecuentas (FAQ)
              </button>
            </h2>
          </div>

          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div class="card-body">
              <div>
                <ul style="list-style-type: disc;">
                  <li>
                    <span><b>¿En qué formato deben subirse los archivos?</b></span>
                    <ul>
                      <li>Los documentos individuales deben estar en formato: PDF, JPEG, PNG, GIF, MOV (QuickTime), ZIP, RAR, DWG, DXF, DOC, DOCX, XLS, XLSX.</li>
                    </ul>
                  </li>
                  <li>
                    <span><b>¿Cómo puedo cambiar mi contraseña?</b></span>
                    <ol>
                      <li>Haz clic en el nombre de tu empresa, ubicado en la esquina superior derecha.</li>
                      <li>Selecciona la opción "Cambiar contraseña".</li>
                      <li>Ingresa tu nueva contraseña y confirma el cambio haciendo clic en "Guardar".</li>
                    </ol>
                  </li>
                  <li>
                    <span><b>Tengo problemas al subir los archivos</b></span>
                    <ol>
                      <li>Verifica que los formatos sean los permitidos y no tengan un tamaño mayor a 50 MB por archivo.</li>
                      <li>Si continuas con algún problema, comunicate con nosotros. <a href="mailto:soporte@baessh.com.mx">soporte@baessh.com.mx</a></li>
                    </ol>
                  </li>
                </ul>
                
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Tutoriales
              </button>
            </h2>
          </div>
          <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
            <div class="card-body">
              <div>
                <p><b>Video tutorial</b></p>
                  <video
                    width= 75%
                    controls
                    :src="videoUrl"
                    style="border-radius: 7px;"
                  >
                    Tu navegador no soporta la etiqueta de video.
                  </video>
              </div>
              <br>
              <p><b>Manual de usuario </b></p>
              <a
                href="/img/Manual.pdf"
                download="Manual-de-Usuario-Portal-BAESSH.pdf"
                class="btn btn-dark"
              >
                📄 Descargar Manual
              </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Contacto BAESSH 
              </button>
            </h2>
          </div>
          <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
            <div class="card-body">
              <span><b>Contacto - Horario de Atención de 8:00AM - 5:00PM</b></span>
              <div>
                <ul class="contact-list">
                  <li>
                    <span><b>Inspectores Protección Civil</b></span>
                    <ul>
                      <li>
                        <span><b>Tec. Jacqueline Martínez Cervantes</b></span>
                        <div class="contact-info">
                          <i class="fa fa-envelope"></i> jacqueline.martinez@baessh.com.mx
                        </div>
                        <div class="contact-info">
                          <i class="fa fa-phone"></i> (667) 726 23 68
                        </div>
                      </li>
                      <li>
                        <span><b>Tec. Luis Ramón Ochoa Sainz</b></span>
                        <div class="contact-info">
                          <i class="fa fa-envelope"></i> ramon.ochoa@baessh.com.mx
                        </div>
                        <div class="contact-info">
                          <i class="fa fa-phone"></i> (667) 126 34 97
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span><b>Soporte técnico Portal BAESSH</b></span>
                    <ul>
                      <li>
                        <span><b>Soporte técnico</b></span>
                        <div class="contact-info">
                          <i class="fa fa-envelope"></i> soporte@baessh.com.mx
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default{
  name: 'CentroAyuda',
  data(){
    return{
      videoUrl: 'https://presware.s3.us-east-1.amazonaws.com/BAESSH+PORTAL.mp4'
    }
  },
  methods: {

  },
  mounted: {

  },
};
</script>

<style>
  .accordion .card {
    border-radius: 10px 10px 10px 10px !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border: none;
  }

  .accordion .card-header {
    background: linear-gradient(135deg, #182579, #774d1b);
  
  }

  .accordion .card-header button {
    color: white;
    font-weight: bold;
  }

  .accordion .card-body {
    background-color: #f8f9fa;
    padding: 1.5rem;
    text-align: left;
  }

  ol > li::marker {
  font-weight: bold;
  }
  .contact-list {
  list-style: none;
  padding: 0;
}

.contact-list {
  list-style: none;
  padding: 0;
}

.contact-list > li {
  background: #f8f9fa; /* Fondo suave */
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.contact-list > li > span {
  font-size: 1.2rem;
  color: #182579;
  display: block;
  margin-bottom: 8px;
}

.contact-list ul {
  list-style: none;
  padding-left: 15px;
}

.contact-list ul li {
  background: white;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 6px;
}

.contact-list ul li span {
  font-weight: bold;
  font-size: 1rem;
  color: #343a40;
}

.contact-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  font-size: 0.9rem;
  color: #555;
  word-break: break-all;
  max-width: 90%;
}

.contact-info i {
  color: #182579;
  font-size: 1rem;
}

</style>